<template>
  <div class="wrapper pt-6">
    <div class="display-1 mb-6">Transactions</div>

    <div
      v-if="transactions.length == 0"
      class="d-flex flex-column align-center mt-6"
    >
      <div class="body-1 mb-2">You have not added any transaction yet.</div>
      <v-btn color="primary" small depressed @click="dialog = true"
        >Add Transaction</v-btn
      >
    </div>

    <template v-else>
      <v-btn
        class="mb-8"
        depressed
        outlined
        color="primary"
        @click="dialog = true"
        >Add Transaction</v-btn
      >

      <v-simple-table class="mb-8 table align-self-center" dense>
        <template>
          <thead>
            <tr>
              <th>email</th>
              <th>price</th>
              <th>Expiration Date</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(transaction, index) in transactions" :key="index">
              <td>{{ transaction.email }}</td>
              <td>{{ transaction.price }} $</td>
              <td>
                {{
                  moment(transaction.expirationDate).format("MM/DD/YYYY")
                }}
              </td>
              <td>{{ transaction.isActive }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>

    <v-dialog v-model="dialog" max-width="500px">
      <form
        class="white d-flex flex-column pa-4"
        @submit.prevent="submit"
        novalidate
        autocomplete="off"
      >
        <div class="title text-center mb-5">New Transaction</div>

        <v-text-field
          label="Coach Email"
          solo
          class="flex-grow-0 mb-1"
          v-model="email"
          type="email"
          dense
          :error-messages="emailErrors"
        ></v-text-field>

        <v-text-field
          label="Price"
          solo
          class="flex-grow-0 mb-1"
          v-model.number="price"
          type="number"
          append-icon="mdi-currency-usd"
          dense
        ></v-text-field>

        <v-menu v-model="menu" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formattedDate"
              clearable
              solo
              dense
              label="Expiration Date"
              readonly
              v-bind="attrs"
              v-on="on"
              @click:clear="expirationDate = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="expirationDate"
            @change="menu = false"
          ></v-date-picker>
        </v-menu>

        <v-btn
          color="primary"
          type="submit"
          small
          depressed
          :disabled="disabledBtn"
          :loading="loader"
          >Add</v-btn
        >
      </form>
    </v-dialog>

    <v-snackbar v-model="snackbar" color="error">
      Something went wrong. Please try again later

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { db } from "@/db";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data() {
    return {
      transactions: [],
      moment,
      dialog: false,
      email: "",
      price: "",
      menu: false,
      expirationDate: moment(new Date())
        .add(1, "y")
        .toISOString()
        .substr(0, 10),
      loader: false,
      snackbar: false,
    };
  },
  validations: {
    email: { required, email },
    price: { required },
    expirationDate: { required },
  },
  computed: {
    formattedDate() {
      if (!this.expirationDate) {
        return "";
      } else {
        return moment(this.expirationDate).format("MM/DD/YYYY");
      }
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email)
        errors.push("Please enter a valid email address.");
      return errors;
    },
    disabledBtn() {
      return (
        !this.$v.email.required ||
        !this.$v.price.required ||
        !this.$v.expirationDate.required
      );
    },
  },
  firestore: {
    transactions: db.collection("mangoPay"),
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loader = true;

      db.collection("mangoPay")
        .doc()
        .set({
          email: this.email,
          price: this.price,
          expirationDate: moment(moment(this.expirationDate).toDate()).unix() * 1000,
          isActive: true,
        })
        .then(() => {
          console.log("hi");
          this.loader = false;
          this.dialog = false;
        })
        .catch((er) => {
          console.log(er);
          this.loader = false;
          this.dialog = false;
          this.snackbar = true;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.email = "";
        this.price = "";
        this.expirationDate = moment(new Date())
          .add(1, "y")
          .toISOString()
          .substr(0, 10);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  min-width: 668px;

  @media screen and (max-width: 708px) {
    min-width: auto;
  }
}
</style>